// extracted by mini-css-extract-plugin
module.exports = {"column":"Column_column__-enME","header":"Column_header__1P7Zj"};